export const labels = {
	'en': {
		pageTitle: 'Edit Profile',
	},
	'zh-hans': {
		pageTitle: '编辑个人资料',
	}
};
